<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-pie-chart"></span> 乐迷
            </span>
        </div>
        <div class="content">
            <el-tabs v-model="activeName"  @tab-click="clickTab">
                <el-tab-pane label="新增" name="1"></el-tab-pane>
                <el-tab-pane label="登录" name="2"></el-tab-pane>
            </el-tabs>
            <div class="data-box">
                <div v-if="activeName == 1" class="total">
                    新增: <b>{{data && data.totalNumSum}} </b> 
                    <router-link class="color-theme" :to="`/report/fans/newFans?rangeStart=${intervalData.startTime} 00:00:00&rangeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                </div>
                <div v-else class="total">
                    登录: <b>{{data && data.totalNumSum}} </b> 
                    <router-link class="color-theme" :to="`/report/fans/loginFans?rangeStart=${intervalData.startTime} 00:00:00&rangeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                </div>
                <el-row v-if="categoryDataList" :gutter="20">
                    <el-col :sm="12" :lg="6">
                        <div v-for="(item,index) in categoryDataList" :key="index" class="category-item">
                            <!--新增-->
                            <template v-if="activeName == 1">
                                <el-image class="logo" :src="platforms1.find( v => item.category == v.name ).logo">
                                    <div slot="error" class="image-slot">
                                        <span class="el-icon-pie-chart"></span>
                                    </div>
                                </el-image>
                                <div class="info">
                                    <div class="num">{{item.category}}新增: {{item.totalNum}}</div>
                                    <div class="ratio color-info">环比: 
                                        <span v-if="item.totalNumRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{item.totalNumRingRatio.value}}</span>
                                        <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{item.totalNumRingRatio.value}}</span>
                                    </div>
                                    <div class="avg color-info">日均: {{item.avgTotalNum}}</div>
                                </div>
                            </template>
                            <!--登录-->
                            <template v-else>
                                <el-image class="logo" :src="platforms2.find( v => item.category == v.name ).logo"></el-image>
                                <div class="info">
                                    <div class="num">{{item.category}}登录: {{item.totalNum}}</div>
                                    <div class="ratio color-info">环比: 
                                        <span v-if="item.totalNumRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{item.totalNumRingRatio.value}}</span>
                                        <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{item.totalNumRingRatio.value}}</span>
                                    </div>
                                    <div class="avg color-info">日均: {{item.avgTotalNum}}</div>
                                </div>
                            </template>
                        </div>    
                    </el-col>
                    <el-col :sm="12" :lg="6">
                        <div id="fansChart1" ref="fansChart1"></div>
                    </el-col>
                    <el-col :lg="12" >
                        <div id="fansChart2" ref="fansChart2"></div>
                    </el-col>
                </el-row>
            </div>
           
        </div>
    </el-card>
</template>

<script>
import xdLogo from '@/assets/img/dashboard/d-logo1.png';
import wyLogo from '@/assets/img/dashboard/d-logo2.png';
// import bdLogo from '@/assets/img/dashboard/d-logo3.png';
import txLogo from '@/assets/img/dashboard/d-logo4.png';
// import wkLogo from '@/assets/img/dashboard/d-logo5.png';
import dmLogo from '@/assets/img/dashboard/d-logo6.png';

import iosLogo from '@/assets/img/dashboard/logo_ios.png';
import androidLogo from '@/assets/img/dashboard/logo_android.png';
import wapCnLogo from '@/assets/img/dashboard/logo_wapcn.png';
import webLogo from '@/assets/img/dashboard/logo_web.png';
import wapEnLogo from '@/assets/img/dashboard/logo_wapen.png';

import { Chart } from '@antv/g2';
export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange:{
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,

            data: null,
            categoryDataList: [],
            
            activeName: "1",
            chart1: null,
            chart2: null,
        }
    },
    computed:{
        platforms1() {
            return [
                {name: '秀动', logo: xdLogo},
                {name: '网易', logo: wyLogo},
                // {name: '百度', logo: bdLogo},
                {name: '腾讯', logo: txLogo},
                // {name: '文客', logo: wkLogo},
                {name: '大麦', logo: dmLogo},
                {name: '其他', logo: ''},
            ]
        },
        platforms2() {
            return [
                {name: 'ios', logo: iosLogo},
                {name: 'android', logo: androidLogo},
                {name: 'wap', logo: wapCnLogo},
                {name: 'web', logo: webLogo},
                {name: 'wap_en', logo: wapEnLogo},
            ]
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.categoryDataList = [];
            this.data = null;
            
            this.dataLoading = true;
            this.$request({
                url: this.activeName == 1 ? "/dashboard/newFans" : "/dashboard/loginFans",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                    category: this.activeName == 1 ? this.platforms1.map(v => v.name) : this.platforms2.map(v => v.name)
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.categoryDataList = result.categoryDataList || [];

                        this.$nextTick(() => {
                            this.drawChart1();
                            this.drawChart2();
                        })
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        clickTab(){
            this.getData();
        },
        drawChart1(){
            if( this.chart1 ) this.chart1.destroy();
            let _data = [];
            _data = [...this.data.totalNumChart.pieSeriesData];
            _data.map( v => {
                v.percent = parseFloat((v.value / this.data.totalNumSum).toFixed(4));
            })

            _data = _data.filter( v => v.value > 0 );
            
            this.chart1 = new Chart({
                container: 'fansChart1',
                autoFit: true,
                height: 420,
            });

            this.chart1.coordinate('theta', {
                radius: 0.6,
            });

            this.chart1.data(_data);

            this.chart1.scale('percent', {
                formatter: (val) => {
                    val = (val * 100).toFixed(2) + '%';
                    return val;
                },
            });

            this.chart1.tooltip({
                showTitle: false,
                showMarkers: false,
            });

            this.chart1.legend('name', {
                position: 'top',
            });
            
            this.chart1
                .interval()
                .adjust('stack')
                .position('percent')
                .color('name')
                .label('percent', (val) => {
                    return {
                        // offset: val > 0.05 ? -30 : null,
                        content: (obj) => {
                            return obj.name //+ ':' + (obj.percent * 100).toFixed(2) + '%';
                        },
                    };
                })
                .tooltip('name*value*percent', (name, value, percent) => {
                    percent = (percent * 100).toFixed(2) + '%';
                    return {
                        name: name,
                        value: value+'('+percent+')',
                    };
                });
            // this.chart1.interaction('element-single-selected');

            this.chart1.render();

        },
        drawChart2(){
            if( this.chart2 ) this.chart2.destroy();
            let _data = [];
            const _dataArry = [...this.data.totalNumChart.lineSeriesData];

            _dataArry.map( item => {
                item.value.map( v => {
                    _data.push({
                        name: item.name,
                        year: v.name,
                        value: parseFloat(v.value)
                    })
                })
            })
            
            this.chart2 = new Chart({
                container: 'fansChart2',
                autoFit: true,
                height: 420,
            });
            this.chart2.data(_data);

            if( this.data.totalNumChart.lineSeriesData[0].value.length > 7 ){
                this.chart2.option('slider', {
                    start: (this.data.totalNumChart.lineSeriesData[0].value.length - 7 ) / this.data.totalNumChart.lineSeriesData[0].value.length,
                    end: 1,
                });
            }

            this.chart2.tooltip({
                showCrosshairs: true,
                shared: true,
            });
            this.chart2.legend('name', {
                position: 'top',
            });
            this.chart2
                .line()
                .position('year*value')
                .color('name')
                .shape('smooth')
                .tooltip('name*value', (name, value) => {
                    // value = this.activeName == 1 ? parseFloat(value).toFixed(2) : value;
                    return {
                        name: name,
                        value: value,
                    };
                });

            this.chart2.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.content{
    .total{
        margin:10px 0 15px 0;
        b{
            font-size: 18px;
            font-weight: 700;
        }
    }
    .category-item{
        display: flex;
        align-items: center;
        margin: 10px 0;
        border: 1px #eee solid;
        padding: 10px;
        font-size: 12px;
        border-radius: 4px;
        .el-image{
            margin-right: 10px;
            width: 46px;
            ::v-deep .image-slot{
                background: none;
                font-size: 46px;
                color: $--color-theme;
            }
        }
        .info{
            flex: 1;
            .num{
                font-size: 14px;
            }
        }
    }
}
</style>